import { render, staticRenderFns } from "./FormStatusOdontograma.vue?vue&type=template&id=4bd63a28"
import script from "./FormStatusOdontograma.vue?vue&type=script&lang=js"
export * from "./FormStatusOdontograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports